import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "../styles/Home.css";
import "../styles/Product.css";
import { HiArrowNarrowRight } from "react-icons/hi";
import ServicesProvideCards from "./ServicesProvideCards";
import { FaArrowRight } from "react-icons/fa6";
import { motion, AnimatePresence } from "framer-motion";

const servicesProvider = [
  {
    id: 1,
    image: "/images/Sec4Img1.png",
    title: "Application Development",
    text: "Scalable and secure web and mobile apps designed to grow with your business using our rapid application development platform.",
    button: "/services/ApplicationDevelopment",
  },
  {
    id: 2,
    image: "/images/Sec4img2.png",
    title: "Product Development",
    text: "Upgrade legacy systems with our modernization strategies for improved performance in Product development",
    button: "/services/ProductDevelopment",
  },
  {
    id: 3,
    image: "/images/Sec4img3.png",
    title: "Staff Augmentation",
    text: "Arshil’s IT staff augmentation services provide businesses with skilled professionals to enhance their development teams.",
    button: "/services/StaffAugumentation",
  },
  {
    id: 4,
    image: "/images/Cloud_optimization.png",
    title: "Cloud Optimization",
    text: "Maximize efficiency and security with serverless and cloud optimization solutions.",
    button: "/services/CloudOptimization",
  },
  {
    id: 5,
    image: "/images/DataAndAnalaticalsolution.png",
    title: "Data and Analytics solutions",
    text: "Arshil’s data and analytics solutions automate the ingestion, curation, and processing of data from multiple sources to provide a 360-degree view of the data.",
    button: "/services/DataAndAnalyticalSolutions",
  },
  {
    id: 6,
    image: "/images/QualityAssurance.png",
    title: "Quality Assurance",
    text: "At Arshil, we provide comprehensive software quality assurance and quality assurance testing services to ensure your applications meet the highest standards.",
    button: "/services/QualityAssurance",
  },
];

const testimonials = [
  {
    content:
      " “Arshil brought our ideas to life with a user-friendly web app. The team was easy to work with and always kept us in the loop. We're thrilled with the results!”  ",
    footerIcon: "🌟",
    footerText: "COO of a FinTech stratup",
  },
  {
    content:
      " “Akscel by Arshil saved so much time and resources to build our application. The team really understood our challenges and delivered exactly what we needed at a fast pace.” ",
    footerIcon: "🌟",
    footerText: "Ops Manager at a Healthcare Organization ",
  },
  {
    content:
      "“Working with some IT experts from the Arshil team was instrumental in our success. Their expertise and attention to detail helped us improve efficiency across the board”",
    footerIcon: "🌟",
    footerText: " CTO at a Manufacturing Firm ",
  },
];


const flipVariant = {
  initial: {
    rotateY: -90,
    opacity: 0,
  },
  animate: {
    rotateY: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: "easeInOut",
    },
  },
  exit: {
    rotateY: 90,
    opacity: 0,
    transition: {
      duration: 0.4,
      ease: "easeInOut",
    },
  },
};

const Home = () => {
  const navigate = useNavigate();

  const [serviceStartIndex, setServiceStartIndex] = useState(0);
  const visibleCards = 3;

  const ServiceshandleNext = () => {
    if (serviceStartIndex + visibleCards < servicesProvider.length) {
      setServiceStartIndex(serviceStartIndex + 1);
    }
  };

  const ServiceshandlePrev = () => {
    if (serviceStartIndex > 0) {
      setServiceStartIndex(serviceStartIndex - 1);
    }
  };

  const [startIndex, setStartIndex] = useState(0);

  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNext = () => {
    setCurrentSlide((prev) =>
      prev < testimonials.length - 1 ? prev + 1 : prev
    );
  };

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const progressPercentage = ((currentSlide + 1) / testimonials.length) * 100;

  const [activeIndex, setActiveIndex] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const accordionData = [
    {
      title: "Akscel Application Platform",
      content:
        " Akscel application platform is a comprehensive application development platform that generates source code in multiple programming languages that can be deployed in a data center or any public cloud.",
    },
    {
      title: "Akscel Data Platform",
      content:
        " Akscel Data Platform is a cloud-native metadata-driven data analytics platform that automates the ingestion, curation, and processing of data from multiple sources to provide a 360-degree view of the data. ",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const cards = [
    {
      title: "Automate",
      subtitle: (
        <>
          {" "}
          Innovate,
          <span className="Container_special_text"> Accelerate</span>
        </>
      ),
      description:
        "Scale confidently and rapidly with custom web application development solutions tailored to meet today’s demands and seize tomorrow's opportunities.",
      button: "Explore services",
      img: "images/Automateimg.png",
      alt: "Custom Web Application Development Services by Arshil",
      link: "/services/ApplicationDevelopment",
    },
    {
      title: "Fast-Track",
      subtitle: "to High-Quality Applications",
      description:
        "Optimize your workflows with intelligent solutions designed for seamless integration and maximum productivity.",
      button: "Explore services",
      link: "/services/ApplicationDevelopment",
      img: "images/Sec1_hero_img2.png",
      alt: "AI Application Development for Smarter Business Solutions",
    },
    {
      title: "Transforming Ideas into",
      subtitle: "Scalable Solutions",
      description:
        "Drive innovation with cutting-edge technologies that deliver exceptional user experiences and business value.",
      button: "Explore services",
      link: "/services/ApplicationDevelopment",
      img: "images/Sec1_hero_img3.png",
      alt: "Mobile Application Development Services for Android and Cloud Apps",
    },
    {
      title: "Precision with Pace.",
      subtitle: "",
      description:
        "Achieve unmatched speed and efficiency with our cloud-based application development services. Build secure, serverless applications that redefine performance.",
      button: "Explore services",
      link: "/services/ApplicationDevelopment",
      img: "images/Sec1_hero_img44.png",
      alt: "Cloud-Based Serverless Application Development Solutions",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === cards.length - 1 ? 0 : prevIndex + 1
      );
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="HomePageContainer">
      {/* Section 1 */}

      <div className="carousel-container">
        <div
          className="carousel-slide"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {cards.map((card, index) => (
            <div className="carousel-item" key={index}>
              <div className="text-content">
                <h1>{card.title}</h1>
                <h3>{card.subtitle}</h3>
                <section className="contentContainer">
                  <p>{card.description}</p>
                  <Link to={card.link}>
                    <button>
                      {card.button}
                      <FaArrowRight className="sec1arrrow" />
                    </button>
                  </Link>
                </section>
              </div>
              <div className="image-content">
                <img className="heroslideImg" src={card.img} alt={card.alt} />
              </div>
            </div>
          ))}
        </div>

        {/* Dots for navigation */}
        <div className="carousel-dots">
          {cards.map((_, index) => (
            <button
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => handleDotClick(index)}
            ></button>
          ))}
        </div>
      </div>

      {/* Section 3 */}

      <motion.div
        className="whyChooseArshil"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.3 }}
      >
        <motion.h1
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: false }}
        >
          Why Choose Arshil?
        </motion.h1>

        <motion.div
          className="whyChooseArshil-sec1"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false, amount: 0.2 }}
        >
          <section className="whyChooseArshil-sec1-in1">
            <img className="Sec3imgone" src="images/Sec3imgone.png" alt="" />
            <p className="whyChooseArshil-sec1-in1-p1">
              At Arshil, we focus on delivering solutions that work for your
              business. As an innovative application development firm, we
              combine decades of expertise with a people-first approach to
              ensure secure, efficient, and innovative results.
            </p>
            <p className="whyChooseArshil-sec1-in1-p2">
              We also launched our in-house code accelerator platform, Akscel,
              that rapidly builds and deploys applications to the cloud while
              following the enterprise guidelines and security standards. This
              has enabled us to optimize resources and increase revenue for
              several businesses across diverse industries.
            </p>
            <button
              className="whyChooseArshil-sec1-in1_button"
              onClick={() => navigate("/about")}
            >
              Learn more
              <FaArrowRight className="sec2demoarrow" />
            </button>
          </section>

          <motion.section
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: false }}
          >
            <section className="whyChooseArshil-sec1-in2-img2">
              <video
                className="H_Video_section"
                src="https://arshil-website.s3.us-east-1.amazonaws.com/arshil-video/Arshil+Website+Video..mp4"
                controls
                autoPlay
                muted
                loop
              />
            </section>
          </motion.section>
        </motion.div>
      </motion.div>

      {/* Section 2 */}

      <motion.div
        className="intoArshilContianer"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.3 }}
      >
        {/* LEFT SECTION: from left to right */}
        <motion.section
          className="intoArshilContianer-in1"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: false }}
        >
          <h1>
            Introducing{" "}
            <span className="intoArshilContianer-in1-sp2">Akscel</span>
          </h1>
          <p className="intoArshilContianer-in1-p1">
            Why write code when you can generate it?
          </p>
          <p className="intoArshilContianer-in1-p2">
            Akscel is a platform that empowers organizations to rapidly build
            and deploy applications with minimal resources—cost, time, effort,
            and human resources. It has two main modules: an application
            development platform and a data platform.
          </p>

          <section className="intoArshilContianer-in1-AC">
            {accordionData.map((item, index) => (
              <div key={index} className="accordion-item">
                <div
                  className="accordion-header"
                  onClick={() => toggleAccordion(index)}
                >
                  <h5 className="accordion-header_h5">{item.title}</h5>
                  <span className="icon">
                    {activeIndex === index ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}
                  </span>
                </div>
                {activeIndex === index && (
                  <p className="accordion-content">{item.content}</p>
                )}
              </div>
            ))}
          </section>

          <button
            className="intoArshilContianer-in1-AC-btn"
            onClick={() => navigate("/products")}
          >
            Schedule a demo
            <FaArrowRight className="sec2demoarrow" />
          </button>
        </motion.section>

        {/* RIGHT SECTION: from right to left */}
        <motion.section
          className="intoArshilContianer_in2"
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.5, delay: 0.4 }}
          viewport={{ once: false }}
        >
          <img
            className="AKImgSec2"
            src="images/AKImgsec2.png"
            alt="Akscel Automated Development Platform for Faster Application Delivery"
          />
        </motion.section>
      </motion.div>

      {/* Sec 4 */}
      <ServicesProvideCards />

      {/* Sec5 industries we servive */}
      <div className="Sec5-industries">
        <h1>Industries We Serve</h1>

        <div className="Sec5-industriesContainer">
          <div className="Sec5-industriesCard">
            <img
              style={{ width: "2.9vw" }}
              className="Fintechimg"
              src="images/Fintechimg.png"
              alt=""
            />
            <img
              style={{ width: "2.9vw" }}
              className="Fintechimg hover-img"
              src="images/Fintech_white_img.png"
              alt="Fintech"
            />
            <h3>Fintech</h3>
            <p>
              We deliver secure fintech application development services with
              Akscel to enable smooth transactions and regulatory compliance.
            </p>
            <button onClick={() => navigate("/industries/Fintech")}>
              Learn more
              <FaArrowRight className="sec5_RA_icon" />
            </button>
          </div>
          <div className="Sec5-industriesCard">
            <img
              className="Fintechimg"
              src="images/HealthCare_img.png"
              alt=""
            />
            <img
              className="Fintechimg hover-img"
              src="images/HealthcareWhiteimg.png"
              alt="Fintech"
            />
            <h3>Healthcare</h3>
            <p>
              Our healthcare application development solutions, powered by
              Akscel, improve patient care and simplify healthcare operations.
            </p>
            <button onClick={() => navigate("/industries/Healthcare")}>
              Learn more
              <FaArrowRight className="sec5_RA_icon" />
            </button>
          </div>
          <div className="Sec5-industriesCard">
            <img className="Fintechimg" src="images/Agri.png" alt="" />
            <img
              className="Fintechimg hover-img"
              src="images/Agriculturewhite.png"
              alt=""
            />
            <h3>Agriculture</h3>
            <p>
              We provide custom application development with Akscel to optimize
              farm management and enhance supply chain operations.
            </p>
            <button onClick={() => navigate("/industries/Agriculture")}>
              Learn more
              <FaArrowRight className="sec5_RA_icon" />
            </button>
          </div>
          <div className="Sec5-industriesCard">
            <img className="Fintechimg" src="images/Hospitality.png" alt="" />
            <img
              className="Fintechimg hover-img"
              src="images/hospilitywhite.png"
              alt=""
            />
            <h3>Hospitality</h3>
            <p>
              Enhance customer experiences with custom mobile app development
              services and web solutions optimised by Akscel.
            </p>
            <button onClick={() => navigate("/industries/Hospitality")}>
              Learn more
              <FaArrowRight className="sec5_RA_icon" />
            </button>
          </div>
        </div>

        <div className="sec5_industriesContainer_two">
          <div className="sec5_industriesContainer_two_card">
            <img className="healthcareimg" src="images/Government.png" alt="" />
            <img
              className="healthcareimg hover-img"
              src="images/Governmentwhite.png"
              alt="Government"
            />
            <h3>Government</h3>
            <p>
              We offer secure government application development services with
              Akscel to improve citizen services and operational efficiency.
            </p>
            <button onClick={() => navigate("/industries/Government")}>
              Learn more
              <FaArrowRight className="sec5_RA_icon" />
            </button>
          </div>
          <div className="sec5_industriesContainer_two_card">
            <img className="healthcareimg" src="images/Education.png" alt="" />
            <img
              className="healthcareimg hover-img"
              src="images/EducationWhite.png"
              alt="Government"
            />
            <h3>Education</h3>
            <p
              className="sec5_industriesContainer_two_card_ep"
              style={{ paddingBottom: "35px" }}
            >
              We design IT solutions for educational institutions using Akscel
              to enhance teaching and learning experiences.
            </p>
            <button onClick={() => navigate("/industries/Education")}>
              Learn more
              <FaArrowRight className="sec5_RA_icon" />
            </button>
          </div>
          <div className="sec5_industriesContainer_two_card">
            <img className="healthcareimg" src="images/Supply.png" alt="" />
            <img
              className="healthcareimg hover-img"
              src="images/Supplychainwhite.png"
              alt="Government"
            />
            <h3>Supply chain</h3>
            <p>
              Streamline logistics and operations with custom solutions powered
              by Akscel to optimize supply chain processes and integration.
            </p>
            <button onClick={() => navigate("/industries/SupplyChain")}>
              Learn more
              <FaArrowRight className="sec5_RA_icon" />
            </button>
          </div>
        </div>
      </div>

      {/* Section 6*/}

      <div className="testimonial_container">
        <h1>Testimonials</h1>

        <AnimatePresence mode="wait">
          <motion.div
            key={currentSlide}
            className="card"
            variants={flipVariant}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <img src="images/el_quotes.png" alt="Quotes" />
            <p>{testimonials[currentSlide].content}</p>
            <div className="iconwithText">
              <span className="iconwithText_icon">
                <img
                  src="svg/Testimonials_Avathar_icon.svg"
                  alt="User avatar"
                />
              </span>
              <h6>{testimonials[currentSlide].footerText}</h6>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="buttons_progressbar_container">
          <div className="controls">
            <button onClick={handlePrev} disabled={currentSlide === 0}>
              &lt;
            </button>
            <button
              onClick={handleNext}
              disabled={currentSlide === testimonials.length - 1}
            >
              &gt;
            </button>
          </div>
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        </div>
      </div>

      {/* Sec 7 */}

      <div className="Sec7_Founderprogram">
        <h1 data-aos="fade-down" data-aos-duration="1000">
          Founders Program
        </h1>

        <div className="Sec7_Founderprogram_card">
          <section
            data-aos="zoom-in-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <h3>Fast Track your MVP</h3>
            <p>
              Starting a new venture? Our Founders Program helps startups launch
              MVPs in record time. Reduce costs, gain expert guidance, and
              retain full IP ownership while we handle development.
            </p>
            <button onClick={() => navigate("/founders-program")}>
              Join the program
              <FaArrowRight className="sec7Farrow" />
            </button>
          </section>

          <section
            data-aos="flip-left"
            data-aos-duration="1000"
            data-aos-delay="400"
          >
            <img
              className="sec7_img2"
              src="images/H_sec8_img1.png"
              alt="Founders Program for Startups to Launch MVP Quickly"
            />
          </section>
        </div>
      </div>

      {/* Sec 8 */}

      <div className="Sec8_container">
        <section
          data-aos="fade-up-right"
          data-aos-duration="1200"
          data-aos-easing="ease-in-out"
        >
          <h1>Ready to Build Your Future</h1>
          <p>
            Let us create something extraordinary together. Contact us to start
            your application development journey. Arshil is always ready to help
            you accelerate with accuracy.
          </p>
        </section>

        <section
          className="Sec8_container_button"
          data-aos="zoom-out"
          data-aos-delay="500"
          data-aos-duration="1400"
        >
          <button onClick={() => navigate("/contact")}>
            Contact us
            <HiArrowNarrowRight className="sec8Carrow" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default Home;
